
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import passwordIsValid from "@/utils/patternValidator";
import BaseView from "@/views/BaseView.vue";

@Component
export default class SetNewPasswordForm extends BaseView {
  // 📦 The invitation token received by email used for authorization
  @Prop({ default: undefined })
  private invitationToken!: string;

  // 📦 The email of the current user
  @Prop({ default: undefined })
  private email!: string;

  // 📦 The entered user password
  private password: string | null = null;

  // 🚩 Flag used for replacing text password with asterixes and the other way around
  private passwordVisible = false;

  // 👮‍♂️ Validation rules for password field
  private passwordRules = [
    (password: string) => !!password || "Password is required",
    (password: string) =>
      passwordIsValid(password) ||
      "Password should consist of at least 8 characters, at least 1 capital letter and at least 1 number",
  ];

  // 📦 The entered user confirm password
  private confirmPassword: string | null = null;

  // 🚩 Flag used for replacing text password with asterixes and the other way around
  private confirmPasswordVisible = false;

  // 👮‍♂️ Validation rules for confirm password field
  private confirmPasswordRules = [
    (confirmPassword: string) =>
      !!confirmPassword || "Confirm password is required",
    (confirmPassword: string) =>
      this.arePasswordsTheSame(confirmPassword) || "Passwords should match!",
  ];

  /**
   * 🚩 Flag used for determining if the whole form is poperly filled
   */
  private get arePasswordsValid(): boolean {
    return (
      passwordIsValid(this.password) &&
      passwordIsValid(this.confirmPassword) &&
      this.password == this.confirmPassword
    );
  }

  /**
   * 🚩 Flag used for dynamically checking whether the 2 passwords are the same
   */
  private arePasswordsTheSame(confirmPassword: string): boolean {
    return confirmPassword === this.password;
  }

  /**
   * 🚀 Sends the user's new password to the API
   */
  private async setNewPassword() {
    if (!this.arePasswordsValid) return;

    Vue.prototype.$api
      .post("/api/v1/resetpassword", {
        token: this.invitationToken,
        password: this.password,
      })
      .then((response: any) => {
        if (response.data.success) {
          // Show success message
          this.showSuccessSnackbar(
            "Your password was successfully changed! Redirecting to login page.."
          );

          // Delay transition to login page
          setTimeout(() => {
            this.clearAuthorizationToken();
            this.$router.push("/");
          }, 800);
        }
      });
  }

  /**
   * 🚮 Clear authorization in case there is already logged in user
   */
  private clearAuthorizationToken() {
    this.$store.commit("SET_IS_AUTHORIZED", false);
    this.$store.commit("SET_AUTHORIZATION_TOKEN", undefined);
    Vue.axios.defaults.headers.common["Authorization"] = "";
  }
}
